'use client'

import { usePathname } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { useFeatureFlags } from '@node-space/hooks'
import { Banner } from '@node-space/storybook-components/dist/Banner'
import Box from '@node-space/storybook-components/dist/Box'

interface UKPromotionalBannerProps {
  countryCode: string
}

export const UKPromotionalBanner = ({ countryCode }: UKPromotionalBannerProps) => {
  const t = useTranslations()
  const isPayout = usePathname()?.includes('payout')

  const { enablePromotionalBanner } = useFeatureFlags()

  if (isPayout && countryCode === 'GB' && enablePromotionalBanner) {
    return (
      <Box className="sticky top-0 z-50 w-full">
        <Banner
          state="info"
          message={t('ukPromotionalText')}
          link={process.env.NEXT_PUBLIC_UK_PROMO_LEARN_MORE_URL}
          linkLabel={t('ukPromotionalLinkText')}
          showInfoIcon={false}
          showCloseBtn={false}
        />
      </Box>
    )
  }
}
